import * as type from 'store/moderator/moderatorTypes'

export function updateModeratorDetails(payload){
    return{
        type: type.UPDATE_MODERATOR_DETAILS_REQUESTED,
        payload: payload
    }
}
